var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8139 34H7.84523C3.69973 34 0.331299 30.3252 0.331299 25.8028V8.19724C0.331299 3.67854 3.69973 0 7.84523 0H26.8174C30.9594 0 34.3313 3.67475 34.3313 8.19724V25.8065C34.3278 30.3252 30.9594 34 26.8139 34ZM7.84523 1.7825C4.60168 1.7825 1.96521 4.65873 1.96521 8.19724V25.8065C1.96521 29.3451 4.60168 32.2213 7.84523 32.2213H26.8174C30.0609 32.2213 32.6974 29.3451 32.6974 25.8065V8.19724C32.6974 4.65873 30.0609 1.7825 26.8174 1.7825H7.84523Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59981 23.5699V9.72618H15.7754V11.3611H8.27882V15.5997H15.3001V17.2233H8.27882V21.935H16.0703V23.5699H6.59981Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3737 23.5699V9.72618H20.0978L26.7619 20.5953V9.72618H28.3715V23.5699H26.6474L19.9834 12.6895V23.5699H18.3737Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEn);
export default __webpack_public_path__ + "static/media/langEN.b2d91255cad86c609ad9abc313ee04b8.svg";
export { ForwardRef as ReactComponent };